import { render, staticRenderFns } from "./MyServicesWidget.vue?vue&type=template&id=0e1a24f4"
import script from "./MyServicesWidget.vue?vue&type=script&lang=js"
export * from "./MyServicesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports